export const enum Permission {
  Full = 'full',
  Read = 'read',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Partial = 'partial',
  UpdatePost = 'updatePost',
  Patch = 'patch',
}

export type Permissions = Record<string, Permission[]>;
